import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../shared/api.service';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { EditCategoryComponent } from './edit-category/edit-category.component';
import { LocalDataSource } from 'ng2-smart-table';
import { ActivatedRoute, Router } from '@angular/router';
import { plainToClass } from 'class-transformer';
import { Categorie } from '../../shared/data/categorie';
import swal from 'sweetalert2';

@Component({
  selector: 'ngx-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {

  categories:any =[];

  param = "";
  
  source: LocalDataSource =  new LocalDataSource();
   settings = {
 
     hideSubHeader: false,
     mode: 'external',
     actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
     },
     add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
     edit: {
       editButtonContent: '<i class="nb-edit"></i>',
       saveButtonContent: '<i class="nb-checkmark"></i>',
       cancelButtonContent: '<i class="nb-close"></i>',
       confirmSave:false
     },
     delete: {
       deleteButtonContent: '<i class="nb-trash"></i>',
       confirmDelete: true,
     },
   columns: {
     id: {
       title: 'ID',
       type: 'number',
       filter: false,
     },
     chemin: {
       title: 'Categorie',
       type: 'string',
     },
     /* formatType: {
       title: 'Type',
       type: 'string',
     }, */
   },
   pager : {
                 perPage :10
   },
  
 };

 constructor(public route: ActivatedRoute, private router:Router,private dialogService: NbDialogService,private apiService:ApiService,private sendeurService:EventSendeurService,private toastr:NbToastrService) { 

  this.route.params.forEach(params => {
      
      this.param = params['type'];

  });


 }
 
 ngOnInit() {

    this.getCategories();
    this.sendeurService.categoryEvent.subscribe(data =>{
      this.getCategories();
    })

  }

 

  getCategories(){

    this.apiService.getAllCategoryProvider(this.param).subscribe(data =>{
     
      data.sort(this.compare);

      this.source.load( plainToClass( Categorie, data) );

      // this.source.setSort(['chemin', 'asc', null]);

      /* const tmps = data as any[];   
      this.categories = tmps.map(tmp => {
        return {
        
          nom: tmp.nom,   
          id:tmp.id,
          description:tmp.description
        };
      
      }); */

    })

  }

  compare(a,b) {

    if(a.chemin < b.chemin)
    return -1;

    if(a.chemin > b.chemin)
    return 1;

    return 0;
   
  }

  
  

  onDelete(event){
    // this.dialogService.open(DeleteCategoryComponent,{ context:{id:$event.data.id}});

    // this.dialogService.open(DeletePageComponent,{context:{id:$event.data.id}});
    const cat = plainToClass( Categorie,  event.data as object);
    
    swal({
      title: 'Suppression page',
      text: 'Voulez - vous vraiment supprimer ' + cat.chemin + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteCategoryProvider(cat.id).subscribe(data =>{
          
          // console.log(data);
          this.source.remove(event.data);
         
        },(err) =>{
          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }
    
          if(err.error.code ===500){
          
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
         }
        })

      },
    }).then((result) => {

      if (result.value) {


        this.toastr.success("Suppréssion réussie", cat.chemin);

      }

      // this.dialogIsNotShow = false;

    });


  }

  
  select($event){
    this.dialogService.open(EditCategoryComponent,{context:{id:$event.data.id}});
  }

  onCreate(event){
    this.createCategory();
  }

  createCategory(){
    this.dialogService.open(EditCategoryComponent,{context:{id:0, cattype:'article'}});
  }

  

}
